import React, { useState} from "react";
import json from "../Component/MySkills/Skill.json";
import Icon from "../Component/MySkills/Icon.jsx";
import { ArrowSmDownIcon } from "@heroicons/react/outline";
import Experience from "./HomePage/Experience";
import webpdf from "../Image/web.pdf";
import Mern from "../Image/MERN.pdf";
import Tailwind from "../Image/tailwind.pdf"
const TechnologyExpertise = () => {
 
  const [animate, setAnimate] = useState();
  const [animate1, setAnimate1] = useState();
  const [animate2, setAnimate2] = useState();
  const onButtonClick = (e, data1) => {
    if (data1 === "web") {
      setAnimate(true);

      setTimeout(() => {
        fetch(webpdf).then((response) => {
          response.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = "HTML_CSS.pdf";
            alink.click();
          });
        });
        setAnimate(false);
      }, 1000);
    }
    if (data1 === "MERN") {
      let data;
      setTimeout(() => {
        // using Java Script method to get PDF file
        data = fetch(Mern).then((response) => {
          response.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = "ReactCertificate.pdf";
            alink.click();
          });
        });
        setAnimate1(false);
      }, 1000);
      if (!data) {
        return <>{setAnimate1(true)}</>;
      }
    }
    if (data1 === "Tail") {
      let data;
      setTimeout(() => {
        // using Java Script method to get PDF file
        data = fetch(Tailwind).then((response) => {
          response.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = "TailwindCertificate.pdf";
            alink.click();
          });
        });
        setAnimate2(false);
      }, 1000);
      if (!data) {
        return <>{setAnimate2(true)}</>;
      }
    }
  };
  return (
    <center>
      <h3 className=" font-bol text-[32px] dark:text-[#FFF] ">
        Technology Expertise
      </h3>
      <div className="horizontal"></div>
      <div className="">
        <div className="mt-8 grid grid-cols-2 gap-4 lg:w-[80%]   lg:grid-cols-4 ">
          {json &&
            json.map((item, index) => {
              return (
                <div className="shadow-lg  shadow-[#30dada] dark:shadow-[#17A6DB]  hover:translate-x-5 hover:duration-500    rounded-[16px] border-[4px] border-[#17A6DB] py-4 dark:border-[#30dada]" >
                  <div>
                    <div className="py-4"> <Icon iconType={item.Icon} /></div>
                   
                    <div className="horizontal1"></div>
                    <p className="  ml-4 mt-4 text-[12px] lg:text-[24px] font-bold  dark:text-[#FFFFFF]">
                      {item.tech}
                    </p>
                    {item.pdf === "web" &&<button
                     onClick={(e) => onButtonClick(e, item.pdf)}
                      className="my-3 px-5 md:px-6 flex text-[12px] font-normal dark:text-white  border-[4px] border-[#17A6DB] dark:border-[#30dada] rounded-[48px] shadow-[40px] duration-200 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500    md:text-2xl"
                      >
                      <p className="mt-1 dark:text-[#FFFFFF]">{animate ? "Downloading..." : "Certificate"}</p>

                      <ArrowSmDownIcon
                        className=

                        "  w-6 mt-1 text-[#172b33] dark:text-[#043d3d] md:w-10 lg:mt-0"

                      />
                    </button>}
                    {item.pdf === "MERN" &&<button
                     onClick={(e) => onButtonClick(e, item.pdf)}
                      className="my-3 px-5 md:px-6 flex text-[12px] font-normal dark:text-white  border-[4px] border-[#17A6DB] dark:border-[#30dada] rounded-[48px] shadow-[40px] duration-200 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500    md:text-2xl"
                      >
                      <p className="mt-1 dark:text-[#FFFFFF]">{animate1 ? "Downloading..." : "Certificate"}</p>

                      <ArrowSmDownIcon
                        className=

                        "  w-6 mt-1 text-[#172b33] dark:text-[#043d3d] md:w-10 lg:mt-0"

                      />
                    </button>}
                    {item.pdf === "Tail" &&<button
                      onClick={(e) => onButtonClick(e, item.pdf)}
                      className="my-3 px-5 md:px-6 flex text-[12px] font-normal dark:text-white  border-[4px] border-[#17A6DB] dark:border-[#30dada] rounded-[48px] shadow-[40px] duration-200 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500    md:text-2xl"
                      >
                      <p className="mt-1 dark:text-[#FFFFFF]">{animate2 ? "Downloading..." : "Certificate"}</p>

                      <ArrowSmDownIcon
                        className=

                        "  w-6   mt-1 text-[#172b33] dark:text-[#043d3d] md:w-10 lg:mt-0"

                      />
                    </button>}
                    </div>
                </div>
              );
            })}
        </div>
       <div className=" mt-[100px] ">
       <Experience />
       </div> 
     
      </div>
    </center>
  );
};

export default TechnologyExpertise;
